import type { StyleSystemProps } from '@withjoy/joykit';
import { styled } from '@withjoy/joykit';
import { ParticleJoyLogo } from '@shared/components/ParticleJoyLogo';

export const StyledFooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 120px 0;
`;

export const ParticleJoyLogoWithPadding = styled(ParticleJoyLogo)`
  padding: 3px 48px 0px 48px;
  & > div {
    & > svg {
      width: 40px;
    }
  }
`;

export const getLinkStyles = (linkColor: string, linkHoverColor: string): StyleSystemProps => ({
  typographyVariant: 'label3',
  textDecoration: 'none',
  fontSize: 'inherit',
  color: linkColor,
  letterSpacing: '-0.03em',
  fontWeight: 'normal',
  _visited: {
    color: linkColor,
  },
  _active: {
    color: linkColor,
  },
  _hover: {
    color: linkHoverColor,
  },
});
